import JWTDecode from "jwt-decode";

const isTokenEpired = token => {
  try {
    const { exp } = JWTDecode(token);
    if (Date.now() / 1000 > exp) {
      return true;
    }
  } catch {
    return true;
  }
  return false;
};

export const isAccessTokenEpired = state => {
  const accessToken = state.iam.accessToken;
  return isTokenEpired(accessToken);
};

export const isLoggedIn = state => {
  const refreshToken = state.iam.refreshToken;
  return !isTokenEpired(refreshToken);
};

export const loggedInUserGuid = state => {
  const accessToken = state.iam.accessToken;
  const tokenParts = accessToken.split(".");
  if (tokenParts.length === 3) {
    let tokenBody = JSON.parse(atob(tokenParts[1]));
    return tokenBody.identity;
  }
  return undefined;
};

export const requestingAuth = state => {
  return state.iam.loading;
};

